import { Card, Input, List, Pagination, Space, Tag, Typography } from "antd";
import React, { useCallback, useState } from "react";
import ModalViewExportTransfer from "../../components/modal/Warehouse/ModalViewExportTransfer";
import { IExportTransfer } from "../../models/Warehouse";
import { useGetWarehouseExportTransfer } from "../../query/WarehouseQuery";
import { debounce } from "lodash";
import { useSearchParams } from "react-router-dom";

const { Text } = Typography;

const WarehouseListExportTransfer: React.FC = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedItem, setSelectedItem] = useState<IExportTransfer | null>(
    null,
  );
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<boolean>(false);
  const [params] = useSearchParams();
  const transferId = params.get("transferId");
  const { data: transferList, isLoading } = useGetWarehouseExportTransfer({
    page,
    limit: pageSize,
    search: searchText,
    transferId: transferId ? parseInt(transferId) : undefined,
  });
  const handleSearch = useCallback((value: string) => {
    debounce(() => {
      setSearchText(value);
      setPage(1);
    }, 500)();
  }, []);

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center mb-2">
        <Input
          placeholder="Nhập từ khóa tìm kiếm"
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 300 }}
          allowClear
        />
      </div>
      <div
        className="overflow-y-auto flex-1"
        style={{ height: "calc(100vh - 200px)" }}
      >
        <List
          itemLayout="vertical"
          dataSource={transferList?.data}
          loading={isLoading}
          renderItem={(item: IExportTransfer) => (
            <Card
              className="mb-2 hover:shadow-md transition-shadow cursor-pointer"
              bodyStyle={{ padding: "12px" }}
              onClick={() => {
                if (isMobile) {
                  setSelectedItem(item);
                  setIsPreviewModalOpen(true);
                }
              }}
              onDoubleClick={() => {
                if (!isMobile) {
                  setSelectedItem(item);
                  setIsPreviewModalOpen(true);
                }
              }}
            >
              <List.Item>
                <List.Item.Meta
                  title={
                    <div className="flex justify-between items-start">
                      <Space direction="vertical" size="small">
                        <Space>
                          <Text strong>Tên phiếu :</Text>
                          <Text
                            style={{
                              color: item.isCompleted ? "#52c41a" : "#ff4d4f",
                              fontWeight: 500,
                            }}
                          >
                            {item.exportTransferName}
                          </Text>
                          <Tag color={item.isCompleted ? "success" : "error"}>
                            {item.isCompleted
                              ? "Đã hoàn tất"
                              : "Đang chờ xác nhận"}
                          </Tag>
                        </Space>
                        <Space>
                          <Text type="secondary">Ghi chú :</Text>
                          <Text>{item.note || "Chưa có ghi chú"}</Text>
                        </Space>
                      </Space>
                      <Space direction="vertical" size="small" align="end">
                        <Space>
                          <Text type="secondary">Người tạo :</Text>
                          <Text strong>{item.createdByUser.fullName}</Text>
                        </Space>
                        <Space>
                          <Text type="secondary">Người xác nhận :</Text>
                          <Text strong>{item.receiver}</Text>
                        </Space>
                        <Text type="secondary">
                          Thời gian tạo :{" "}
                          {new Date(item.createdAt).toLocaleString()}
                        </Text>
                      </Space>
                    </div>
                  }
                />
              </List.Item>
            </Card>
          )}
        />
      </div>
      <div className="flex justify-end">
        {transferList?.data && (
          <Pagination
            className="my-2"
            current={page}
            pageSize={pageSize}
            total={transferList?.pagination.total}
            onChange={(newPage: number) => setPage(newPage)}
            onShowSizeChange={(_: number, size: number) => setPageSize(size)}
            showQuickJumper
            showSizeChanger
          />
        )}
      </div>
      {selectedItem && (
        <ModalViewExportTransfer
          selectedItems={selectedItem}
          open={isPreviewModalOpen}
          onOk={() => setIsPreviewModalOpen(false)}
          onCancel={() => setIsPreviewModalOpen(false)}
        />
      )}
    </div>
  );
};

export default WarehouseListExportTransfer;
